export const paginationArrowType = {
  first: 'first',
  prev: 'prev',
  next: 'next',
  last: 'last',
};
